var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9868 54.7765C27.4112 54.7765 28.5658 53.6219 28.5658 52.1976C28.5658 50.7733 27.4112 49.6187 25.9868 49.6187C24.5625 49.6187 23.4079 50.7733 23.4079 52.1976C23.4079 53.6219 24.5625 54.7765 25.9868 54.7765Z",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6842 54.7765C46.1085 54.7765 47.2632 53.6219 47.2632 52.1976C47.2632 50.7733 46.1085 49.6187 44.6842 49.6187C43.2599 49.6187 42.1053 50.7733 42.1053 52.1976C42.1053 53.6219 43.2599 54.7765 44.6842 54.7765Z",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H14.9091L20.8782 38.9271C21.0819 39.9561 21.6397 40.8804 22.4541 41.5383C23.2685 42.1961 24.2875 42.5456 25.3327 42.5255H46.9818C48.0271 42.5456 49.0461 42.1961 49.8605 41.5383C50.6748 40.8804 51.2327 39.9561 51.4364 38.9271L55 20.1752H17.1364",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1364 20.1748L20.8782 38.9269C21.0819 39.9559 21.6397 40.8802 22.4541 41.538C23.2685 42.1959 24.2875 42.5454 25.3327 42.5253H46.9818C48.0271 42.5454 49.0461 42.1959 49.8605 41.538C50.6749 40.8802 51.2327 39.9559 51.4364 38.9269L55 20.1749L17.1364 20.1748Z",
    fill: "#2E61A1",
    fillOpacity: 0.1,
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 24C34.8954 24 34 24.8954 34 26V29H31C29.8954 29 29 29.8954 29 31C29 32.1046 29.8954 33 31 33H34V36C34 37.1046 34.8954 38 36 38C37.1046 38 38 37.1046 38 36V33H41C42.1046 33 43 32.1046 43 31C43 29.8954 42.1046 29 41 29H38V26C38 24.8954 37.1046 24 36 24Z",
    fill: "#2E61A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCart);
export default __webpack_public_path__ + "static/media/business_cart.61d49f3e44c99996ed72cdecf3ce518d.svg";
export { ForwardRef as ReactComponent };